import { jsx as _jsx } from "react/jsx-runtime";
import AntInputNumber from 'antd/es/input-number';
const InputNumber = (props) => _jsx(AntInputNumber, Object.assign({ controls: false }, props));
export default InputNumber;
